import React from 'react';
import { RouteComponentProps } from 'react-router';
import PageContainer from './PageContainer';
import PaddedContent from '../components/housing/PaddedContent';
import { useMessageGetter } from 'react-message-context';
import { H2 } from './forms/index';
import WordPressContent, { WpPostType } from '../components/wordpress/WordPressContent';
import { useAppState } from '../context/appContext';
import { getContentBlockSlug } from './pageUtils';
import ResidentCommitteeForms from './forms/ResidentCommitteeForms';
import { Button } from '../components/common';
import styled from 'styled-components/macro';
import { scrollToElement } from '../utils';

const FormsButton = styled(Button)`
  margin-top: 40px;
`;

const ResidentCommitteePage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('');
  const { language } = useAppState();

  const scrollToForms = () => {
    scrollToElement('ResidentCommitteeForms');
  };

  return (
    <PageContainer history={history}>
      <PaddedContent>
        <H2>{t('living.committee.title')}</H2>
        <FormsButton primary icon="trailing" size="medium" onClick={scrollToForms}>
          {t('forms.committee.title')}
        </FormsButton>
        <WordPressContent
          slug={getContentBlockSlug('asukastoimikunta', language)}
          postType={WpPostType.CONTENT_BLOCKS}
        />
        <ResidentCommitteeForms />
      </PaddedContent>
    </PageContainer>
  );
};

export default ResidentCommitteePage;
